<template>
	<section class="iv2-page-header">
		<div
			v-if="items.header_type == 'with_catchcopy'"
			class="iv2-page-header-type1 theme-b__page-header-bg--with-catchcopy fit-img overflow-hidden"
		>
			<img
				:src="items.header_contents.image"
				class="iv2-page-header__img"
				:alt="items.title + alt_text"
			/>
			<div class="iv2-page-header__title theme-b__page-header-title--with-catchcopy position-relative">
				<h1 class="iv2-page-header__main-title">{{ items.title }}</h1>
				<p class="iv2-page-header__sub-title m-0 mt-1">{{ items.subtitle }}</p>
			</div>
			<div class="iv2-page-header__text theme-b__page-header-text--with-catchcopy text-center">
				<div class="row">
					<div class="col-12 px-md-5 px-4">
						<p v-html="items.header_contents.catch_copy_sub" class="iv2-page-header__sub-lead"></p>
						<p v-html="items.header_contents.catch_copy_main" class="iv2-page-header__main-lead"></p>
						<p v-html="items.header_contents.lead_line" class="iv2-page-header__description"></p>
					</div>
				</div>
			</div>
		</div>
		<div
			v-else-if="items.header_type == 'with_bg'"
			class="iv2-page-header-type2 theme-b__page-header-bg--with-catchcopy fit-img overflow-hidden"
		>
			<img
				:src="items.header_contents.image"
				class="iv2-page-header__img"
				:alt="items.title + alt_text"
			/>

			<div class="iv2-page-header__title theme-b__page-header-text--with-catchcopy position-relative">
				<h1 class="iv2-page-header__main-title h4 m-0">{{ items.title }}</h1>
				<p class="iv2-page-header__sub-title m-0 mt-1">{{ items.subtitle }}</p>
			</div>
		</div>
		<div v-else-if="items.header_type == 'title_only'" class="iv2-page-header-type3 overflow-hidden">
			<div class="iv2-page-header__title position-relative">
				<h1 class="iv2-page-header__main-title theme-b__page-header-title h4 m-0">{{ items.title }}</h1>
				<p
					class="iv2-page-header__sub-title theme-b__page-header-sub-title m-0 mt-1"
				>{{ items.subtitle }}</p>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	props: ["items"],

	data() {
		return {
			alt_text: "ページのカバーイメージ",
		};
	},
};
</script>

<style lang="scss">
.iv2-page-header {
	text-align: center;

	.iv2-page-header__title {
		.iv2-page-header__main-title {
			font-size: 1.5rem;
			border-bottom: 1px solid;
			padding: 30px 30px 5px;
			font-weight: bold;
			display: inline-block;
		}

		.iv2-page-header__sub-title {
			font-size: 12px;
			font-weight: 400;
		}
	}

	/* ページヘッダー(タイプ1) */

	.iv2-page-header-type1 {
		padding-bottom: 80px;

		.iv2-page-header__text {
			.iv2-page-header__main-lead {
				line-height: 1.2;
			}

			.iv2-page-header__sub-lead {
				line-height: 1.5;
			}
		}
	}

	.iv2-page-header-type1,
	.iv2-page-header-type2 {
		text-shadow: 0px -1px 10px #00000085;

		.iv2-page-header__img {
			width: 100%;
			height: 100%;
			opacity: 0.6;
		}
	}
}

/* PC */
@media (min-width: 1200px) {
	.iv2-page-header-type1 {
		.iv2-page-header__title {
			padding: 50px 50px 10px;
		}
		.iv2-page-header__text {
			.iv2-page-header__main-lead {
				font-size: 2.5rem;
			}

			.iv2-page-header__sub-lead {
				font-size: 1.4rem;
			}

			.iv2-page-header__description {
				margin-top: 30px;
				line-height: 1.3;
				font-size: 1.3rem;
			}
		}
	}

	.iv2-page-header-type2,
	.iv2-page-header-type3 {
		.iv2-page-header__title {
			padding: 100px 50px;
		}
	}
}

/* TABLET or SP */
@media (max-width: 1199px) {
}

/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
	.iv2-page-header__title {
		padding: 60px 30px;
	}

	.iv2-page-header-type1 {
		.iv2-page-header__title {
			padding: 30px;
		}

		.iv2-page-header__text {
			.iv2-page-header__description {
				line-height: 1.5;
			}

			.iv2-page-header__main-lead {
				font-size: 2rem;
			}
		}
	}
}

/* SP Only */
@media (max-width: 767px) {
	.iv2-page-header {
		.iv2-page-header__title {
			padding: 50px 20px;

			.iv2-page-header__main-title {
				font-size: 1.3rem;
			}
		}

		.iv2-page-header-type1 {
			padding-bottom: 30px;

			.iv2-page-header__text {
				padding: 0 20px;

				.iv2-page-header__main-lead {
					font-size: 1.3rem;
				}

				.iv2-page-header__description {
					font-size: 0.9rem;
				}
			}
		}
	}
}
</style>
